// eslint-disable-next-line no-restricted-imports
import { Text as ReactNativeText, TextProps } from 'react-native';
import React, { forwardRef } from 'react';
import { isPatientApp } from '@/config/constants';
import { Text as AppText } from '@/components/ui/therapist/Text';
import { styles } from './styles';

interface CustomTextProps extends TextProps {
  isResponsiveText?: boolean;
}

export const Text = forwardRef<ReactNativeText, CustomTextProps>(
  (
    {
      children,
      isResponsiveText,
      style,
      allowFontScaling = false,
      ...textProps
    },
    ref,
  ) => {
    return (
      <>
        {isPatientApp || isResponsiveText ? (
          <ReactNativeText
            ref={ref}
            style={[styles.defaultText, style]}
            allowFontScaling={allowFontScaling}
            {...textProps}
          >
            {children}
          </ReactNativeText>
        ) : (
          <AppText
            style={style}
            {...textProps}
            onPress={textProps.onPress}
            ref={ref}
          >
            {children}
          </AppText>
        )}
      </>
    );
  },
);

Text.displayName = 'Text';
